module.exports = __webpack_public_path__ + "img/1561081641.bc8725ac.jpg";